module.exports = __webpack_public_path__ + "img/icon-qrcode.a144b52f.svg";